<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <div class="form-base__title">
              Реквизиты счета для возврата должнику безналичных денежных
              средств, направленных на депонирование
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.debtorAccountBankDetails" />
      </div>

      <Footer
        @prev-btn-click="
          () =>
            leaveStep({
              stepThis: this,
              direction: StepDirection.PREV,
              step: StepName.S4,
            })
        "
        @next-btn-click="
          () =>
            leaveStep({
              stepThis: this,
              direction: StepDirection.NEXT,
              step: StepName.S4,
            })
        "
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';

import { getValidationErrorText } from '@/utils/validate';
import { checkInvalid, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';

export default {
  name: 'Step4',
  components: {
    Footer,
    BankDetails,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    getValidationErrorText,
    invalidFields: [],
    debtorAccountBankDetails: cloneDeep(bankDetails),
  }),
  validations: {
    debtorAccountBankDetails: bankDetailsValidation,
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    touchFields() {
      this.invalidFields = [];
      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    assemblyModel() {
      return cloneDeep(this.debtorAccountBankDetails);
    },

    prefillDraft() {
      if (!ServicesModule.statement.debtorAccountBankDetails) return;

      this.debtorAccountBankDetails = cloneDeep(
        ServicesModule.statement.debtorAccountBankDetails
      );
    },
  },
};
</script>
